import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../components/AuthContext';
import AdminLayout from '../components/AdminLayout';
import './AdminLoverlistCssPage.css';

// Configurazione CSS
const CSS_DOMAIN_ID = '5622098383'; // CSS_DOMAIN_ID corretto

const AdminLoverlistCssPage = () => {
  const { user } = useContext(AuthContext);
  const [cssProducts, setCssProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [uploadResult, setUploadResult] = useState(null);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [hasMore, setHasMore] = useState(false);

  // Funzione per determinare lo status del prodotto CSS
  const getCssProductStatus = (cssProductStatus) => {
    if (!cssProductStatus) {
      return { status: 'no-status', label: 'No Status', color: 'gray' };
    }

    // Controlla se ci sono errori
    if (cssProductStatus.itemLevelIssues && cssProductStatus.itemLevelIssues.length > 0) {
      const hasDisapprovedIssues = cssProductStatus.itemLevelIssues.some(issue => 
        issue.servability === 'disapproved'
      );
      
      if (hasDisapprovedIssues) {
        return { 
          status: 'disapproved', 
          label: 'Disapproved', 
          color: 'red',
          issues: cssProductStatus.itemLevelIssues.filter(issue => issue.servability === 'disapproved')
        };
      }
    }

    // Controlla destinationStatuses
    if (cssProductStatus.destinationStatuses && cssProductStatus.destinationStatuses.length > 0) {
      const hasDisapprovedDestinations = cssProductStatus.destinationStatuses.some(dest => 
        dest.disapprovedCountries && dest.disapprovedCountries.length > 0
      );
      
      if (hasDisapprovedDestinations) {
        return { 
          status: 'disapproved', 
          label: 'Disapproved', 
          color: 'red',
          destinations: cssProductStatus.destinationStatuses.filter(dest => 
            dest.disapprovedCountries && dest.disapprovedCountries.length > 0
          )
        };
      }
    }

    // Se non ci sono errori, probabilmente è approved o pending
    return { status: 'approved', label: 'Approved', color: 'green' };
  };

  const fetchCssProducts = async (pageToken = null, append = false) => {
    try {
      if (append) {
        setLoadingMore(true);
      } else {
        setLoading(true);
        setCssProducts([]);
        setNextPageToken(null);
        setHasMore(false);
      }
      
      const params = new URLSearchParams();
      if (pageToken) {
        params.append('pageToken', pageToken);
      }
      params.append('pageSize', '50');
      
      const response = await fetch(`/api/google-shopping/loverlist/css-products?${params}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Errore nel caricamento prodotti CSS');
      }

      const data = await response.json();
      if (data.success) {
        // Debug: log della struttura dei dati per investigare lo status
        if (data.data.products.length > 0) {
          console.log('[CSS DEBUG] Prima prodotto:', data.data.products[0]);
          console.log('[CSS DEBUG] cssProductStatus:', data.data.products[0].cssProductStatus);
        }
        
        if (append) {
          setCssProducts(prev => [...prev, ...data.data.products]);
        } else {
          setCssProducts(data.data.products);
        }
        setNextPageToken(data.data.nextPageToken);
        setHasMore(data.data.hasMore);
      } else {
        throw new Error(data.message || 'Errore nel recupero prodotti CSS');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const loadMoreProducts = () => {
    if (nextPageToken && !loadingMore) {
      fetchCssProducts(nextPageToken, true);
    }
  };

  const handleUploadProducts = async () => {
    try {
      setUploading(true);
      setError(null);
      setUploadResult(null);

      const response = await fetch('/api/google-shopping/loverlist/upload-products-css', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Errore nel caricamento prodotti');
      }

      const data = await response.json();
      setUploadResult(data.data);
      
      // Mostra messaggio di successo con informazioni test
      if (data.success) {
        if (data.data.limitReached) {
          alert(`Caricamento CSS TEST completato: ${data.data.uploaded} prodotti CSS caricati (limite 1000 raggiunto)`);
        } else {
          alert(`Caricamento CSS completato: ${data.data.uploaded} prodotti CSS caricati`);
        }
      }
      
      // Ricarica prodotti CSS dopo il caricamento
      await fetchCssProducts();
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return '#28a745';
      case 'pending':
        return '#ffc107';
      case 'suspended':
        return '#dc3545';
      default:
        return '#6c757d';
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="loverlist-css-container">
          <div className="loverlist-css-loading">
            <div style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Caricamento...</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
              {[...Array(4)].map((_, i) => (
                <div key={i} style={{ 
                  background: 'white', 
                  borderRadius: '8px', 
                  padding: '1.5rem',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  border: '1px solid #e9ecef'
                }}>
                  <div style={{ height: '1rem', background: '#e9ecef', borderRadius: '4px', width: '75%', marginBottom: '1rem' }}></div>
                  <div style={{ height: '1.5rem', background: '#e9ecef', borderRadius: '4px', width: '50%', marginBottom: '0.5rem' }}></div>
                  <div style={{ height: '1rem', background: '#e9ecef', borderRadius: '4px', width: '33%' }}></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout>
        <div className="loverlist-css-container">
          <div className="loverlist-css-error">
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
              <span style={{ fontSize: '1.25rem' }}>⚠️</span>
              <h3 style={{ margin: 0, fontSize: '1.1rem' }}>Errore</h3>
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <p>{error}</p>
            </div>
            <button
              onClick={fetchCssProducts}
              className="loverlist-css-btn loverlist-css-btn-danger"
            >
              Riprova
            </button>
          </div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="loverlist-css-container">
        {/* Header */}
        <div className="loverlist-css-header">
          <div>
            <h1 className="loverlist-css-title">Pagine CSS</h1>
            <p style={{ marginTop: '0.5rem', color: '#6b7280' }}>
              Gestione prodotti CSS per il sub-account Loverlist (ID: {CSS_DOMAIN_ID})
            </p>
          </div>
          <div className="loverlist-css-actions">
            <Link
              to="/admin/css-overview"
              className="loverlist-css-btn loverlist-css-btn-secondary"
            >
              ← Torna a CSS Overview
            </Link>
            <button
              onClick={handleUploadProducts}
              disabled={uploading}
              className="loverlist-css-btn loverlist-css-btn-primary"
            >
              {uploading ? 'Caricamento...' : 'Carica Prodotti CSS'}
            </button>
          </div>
        </div>

        {/* CSS Products List */}
        <div className="loverlist-css-products">
          <div className="loverlist-css-products-header">
            <h2 className="loverlist-css-products-title">Prodotti CSS</h2>
            <div className="loverlist-css-products-actions">
              <span className="loverlist-css-products-count">Caricati: {cssProducts.length}</span>
              <button
                onClick={() => fetchCssProducts()}
                className="loverlist-css-btn loverlist-css-btn-sm"
                disabled={loading}
              >
                {loading ? 'Caricamento...' : 'Carica Prodotti'}
              </button>
            </div>
          </div>
          
          {loading && cssProducts.length === 0 ? (
            <div className="loverlist-css-loading">
              <p>Caricamento prodotti CSS...</p>
            </div>
          ) : cssProducts.length === 0 ? (
            <div className="loverlist-css-no-products">
              <p>Nessun prodotto CSS caricato</p>
              <p style={{ fontSize: '0.875rem', color: '#6b7280', marginTop: '0.5rem' }}>
                Clicca su "Carica Prodotti" per visualizzare i prodotti CSS
              </p>
            </div>
          ) : (
            <>
              <div className="loverlist-css-products-list">
                {cssProducts.map((product, index) => {
                // Usa il cppLink dall'API invece di calcolarlo
                const productLink = product.attributes && product.attributes.cppLink ? product.attributes.cppLink : null;
                const productImage = product.attributes && product.attributes.imageLink ? product.attributes.imageLink : null;
                
                return (
                  <div key={index} className="loverlist-css-product-item">
                    <div className="loverlist-css-product-image">
                      {productImage ? (
                        <img 
                          src={productImage} 
                          alt={product.attributes?.title || 'Prodotto'} 
                          className="loverlist-css-product-img"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                      ) : null}
                      <div className="loverlist-css-product-no-image" style={{ display: productImage ? 'none' : 'flex' }}>
                        <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                          <circle cx="8.5" cy="8.5" r="1.5"/>
                          <polyline points="21,15 16,10 5,21"/>
                        </svg>
                      </div>
                    </div>
                    
                    <div className="loverlist-css-product-info">
                      <div className="loverlist-css-product-id">{product.rawProvidedId}</div>
                      <div className="loverlist-css-product-details">
                        <span>Lingua: {product.contentLanguage}</span>
                        <span>Feed: {product.feedLabel}</span>
                        {product.attributes && product.attributes.title && (
                          <span className="loverlist-css-product-title">{product.attributes.title}</span>
                        )}
                      </div>
                      {productLink && (
                        <div className="loverlist-css-product-link">
                          <a 
                            href={productLink} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="loverlist-css-product-link-btn"
                          >
                            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                            Vedi Prodotto
                          </a>
                        </div>
                      )}
                    </div>
                    
                    <div className="loverlist-css-product-status">
                      {(() => {
                        const statusInfo = getCssProductStatus(product.cssProductStatus);
                        return (
                          <span 
                            className={`loverlist-css-status-badge loverlist-css-status-${statusInfo.status}`}
                            title={statusInfo.issues ? 
                              `Errori: ${statusInfo.issues.map(issue => issue.description).join(', ')}` : 
                              statusInfo.destinations ? 
                                `Destinazioni disapprovate: ${statusInfo.destinations.map(dest => dest.destination).join(', ')}` :
                                statusInfo.label
                            }
                          >
                            {statusInfo.label}
                          </span>
                        );
                      })()}
                    </div>
                  </div>
                );
                })}
              </div>
              
              {/* Load More Button */}
              {hasMore && (
                <div className="loverlist-css-load-more">
                  <button
                    onClick={loadMoreProducts}
                    disabled={loadingMore}
                    className="loverlist-css-btn loverlist-css-btn-secondary"
                  >
                    {loadingMore ? 'Caricamento... ' : 'Carica Altri Prodotti'}
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        {/* Upload Results */}
        {uploadResult && (
          <div className="loverlist-css-upload-results">
            <div className="loverlist-css-upload-header">
              <h3 className="loverlist-css-upload-title">Risultati Caricamento</h3>
            </div>
            
            <div className="loverlist-css-upload-summary">
              <div className="loverlist-css-upload-stat">
                <span className="loverlist-css-upload-label">Seller Processati:</span>
                <span className="loverlist-css-upload-value">{uploadResult.totalSellers}</span>
              </div>
              <div className="loverlist-css-upload-stat">
                <span className="loverlist-css-upload-label">Prodotti Totali:</span>
                <span className="loverlist-css-upload-value">{uploadResult.totalProducts}</span>
              </div>
              <div className="loverlist-css-upload-stat">
                <span className="loverlist-css-upload-label">Caricati con Successo:</span>
                <span className="loverlist-css-upload-value loverlist-css-upload-success">{uploadResult.uploaded}</span>
              </div>
              <div className="loverlist-css-upload-stat">
                <span className="loverlist-css-upload-label">Errori:</span>
                <span className="loverlist-css-upload-value loverlist-css-upload-error">{uploadResult.errors.length}</span>
              </div>
            </div>

            {/* Seller Statistics */}
            {uploadResult.sellerStats && uploadResult.sellerStats.length > 0 && (
              <div className="loverlist-css-seller-stats">
                <h4 className="loverlist-css-seller-stats-title">Dettagli per Seller</h4>
                <div className="loverlist-css-seller-stats-grid">
                  {uploadResult.sellerStats.map((seller, index) => (
                    <div key={index} className="loverlist-css-seller-stat-card">
                      <div className="loverlist-css-seller-name">{seller.sellerName}</div>
                      <div className="loverlist-css-seller-details">
                        <span>Prodotti: {seller.products}</span>
                        <span>Caricati: {seller.uploaded}</span>
                        {seller.errors.length > 0 && (
                          <span className="loverlist-css-seller-error">Errori: {seller.errors.length}</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Error Details */}
            {uploadResult.errors && uploadResult.errors.length > 0 && (
              <div className="loverlist-css-error-details">
                <h4 className="loverlist-css-error-details-title">Dettagli Errori</h4>
                <div className="loverlist-css-error-list">
                  {uploadResult.errors.slice(0, 10).map((error, index) => (
                    <div key={index} className="loverlist-css-error-item">
                      <span className="loverlist-css-error-seller">{error.sellerName || 'N/A'}</span>
                      <span className="loverlist-css-error-message">{error.error || error.message || 'Errore sconosciuto'}</span>
                    </div>
                  ))}
                  {uploadResult.errors.length > 10 && (
                    <div className="loverlist-css-error-more">
                      ... e altri {uploadResult.errors.length - 10} errori
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Quick Actions */}
        <div className="loverlist-css-quick-actions">
          <div className="loverlist-css-quick-actions-header">
            <h3 className="loverlist-css-quick-actions-title">Azioni Rapide</h3>
          </div>
          
          <div className="loverlist-css-quick-actions-grid">
            <a
              href={`https://merchants.google.com/mc/merchantprofile/overview?merchantId=${CSS_DOMAIN_ID}`}
              target="_blank"
              rel="noopener noreferrer"
              className="loverlist-css-quick-action"
            >
              <div className="loverlist-css-quick-action-icon">
                <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </div>
              <div className="loverlist-css-quick-action-content">
                <h4>Google Merchant Center</h4>
                <p>Apri il merchant center per gestire i prodotti</p>
              </div>
            </a>

            <button
              onClick={() => fetchCssProducts()}
              className="loverlist-css-quick-action"
            >
              <div className="loverlist-css-quick-action-icon">
                <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </div>
              <div className="loverlist-css-quick-action-content">
                <h4>Aggiorna Prodotti</h4>
                <p>Ricarica la lista dei prodotti CSS</p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminLoverlistCssPage; 